// extracted by mini-css-extract-plugin
export default {"pagination-container":"gASMpG","paginationContainer":"gASMpG"};